import React from 'react';
import "./live-goods.scss"
import Verbiage from '../../verbiage.js';
import Warning from "../../warning";


function LiveGoods({ fulfillmentDetails }){
    const { storeName, isInSeason } = fulfillmentDetails;

    const liveGoodMessaging = isInSeason ?
    (<div>
        <span className="live-goods__check"></span>
        <span className="live-goods__primary-content--in-season"> {"  " + Verbiage.LIVE_GOODS_IN_SEASON} </span>
        <div className="live-goods__secondary-content">
            Stop by <span className="u__bold">{storeName}</span> to see this variety and more in person.
        </div>
    </div>):
    (<div>
        <span className="alert-inline--warning">
				<span className="dai_warningMessage">
                    {"  " + Verbiage.LIVE_GOODS_OUT_OF_SEASON}
                </span>
        </span>
        <div className="live-goods__secondary-content">
            Visit <span className="u__bold">{storeName}</span> next season to find this plant and more.
        </div>
    </div>)


    return (
        <div className="live-goods__wrapper live-goods__wrapper--left">
            <div className="live-goods__heading">How To Get It</div>
            {liveGoodMessaging}
        </div>
    );
}

export default LiveGoods;
